'use client';

type Link = {
  label: string;
  url: string;
};

const getLinksFromReferenceLinksString = (referenceLinks?: string): Link[] =>
  referenceLinks
    ?.replace(/(\s+)(?=[^[\]]*(?:\[|$))/g, '')
    .split(';')
    .map((link: string) => {
      const [label, url] = link.split('](');
      return {
        label: label?.replace('[', '') ?? '',
        url: url?.replace(')', '') ?? '',
      };
    }) ?? [];

type ReferenceLinksProps = {
  referenceLinksString?: string;
};

const ReferenceLinks: React.FC<ReferenceLinksProps> = ({
  referenceLinksString,
}) => {
  const links = getLinksFromReferenceLinksString(referenceLinksString);
  return links.length > 0 ? (
    <div className="my-2 flex flex-col gap-1">
      {links.map((link: Link, index: number) => (
        <a
          key={index}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-text-primary underline hover:opacity-90"
        >
          {link.label}
        </a>
      ))}
    </div>
  ) : null;
};

export default ReferenceLinks;
